/**
 * useGlassStatus — the freshness strip behind the Glass (wave glass-1, #790).
 *
 * Reads GET /api/glass — build-baked freshness stamps only (canon generation
 * time, source commit, register checked_on span). The canon itself is
 * bundled (GLASS_CANON), so the pane renders with no fetch; the stamps only
 * change on a deploy, so the poll is slow — it exists so a deploy landing
 * while the tab sits open shows up without a hard refresh.
 */

import { GlassStatusResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const useGlassStatus = createPollingQuery({
  queryKey: ["glass-status"] as const,
  path: "/api/glass",
  schema: GlassStatusResponseSchema,
  refetchIntervalMs: 5 * 60_000,
});
